export default __webpack_public_path__ + "static/media/delete_new.d0a2f0c2.svg";